import React from "react";

function RejecetedReview(){
  return(
            <div className="verify-state-box">
            <div className="verify-state-inner">
              <div className="verify-state-icon"><span></span><span></span><span></span></div>
              <p>Failed</p>
              <button className="btn-retry">retry again</button>
            </div>
          </div>
  )
}
export default RejecetedReview;